/**
 * Red Tiki Filtering Engine for Homepage Products Area
 * - uses collections and tags to filter and display products
 * - products are loaded as ajax data and rendered client-side
 **/

function FilteringEngine(opts)
{
  
  var options = $.extend({
  	
    collectionFilterSelector: '#collection-filters input',
    
    tagFilterSelector: '#tag-filters input',
    
    filterTargetSelector: '#filter-target',
    
    filterPrevLinkSelector: '#filter-page-prev',
    filterNextLinkSelector: '#filter-page-next',
    
    beforeFilter: function(self)
    {
    	//return false to block...
      	return true;
    },
    
    afterFilter: function(self)
    {
    	
      	
    },
    
    beforeUpdate: function(self)
    {
      
    }
    
  },opts);
  
  return {
  	
    currentlyFiltering: false,
    activeCollectionRadio: false,
    activeTagRadio: false,
    filterTarget: false,
    
    activeAjaxPath: false,
    lastAjaxPath: false,
    
    //initialise...
    init: function()
    {
    	
      	var self = this;
      	
      	this.filterTarget = $(options.filterTargetSelector);
      	
      	if (! this.filterTarget)
        {
          alert('Error: The filter target selector is incorrect.');
        }
      
        $(options.collectionFilterSelector).change(function(e){
        	
          	if (! self.currentlyFiltering)
            {
          		self.doFilter();
            }
          	else
            {
              	self.activeCollectionRadio.click();
            	e.preventDefault();
              	return false;
            }
          
        });
      
      	$(options.tagFilterSelector).change(function(e){
        	
          	if (! self.currentlyFiltering)
            {
          		self.doFilter();
            }
          	else
            {
              	self.activeTagRadio.click();
            	e.preventDefault();
              	return false;
            }
          
        });
      
        $(options.filterPrevLinkSelector).click(function(e){
          	self.doPage($(this).data('src'));
          	e.preventDefault();
			return false;
        });
      
      	$(options.filterNextLinkSelector).click(function(e){
          	self.doPage($(this).data('src'));
          	e.preventDefault();
			return false;
        });
      
    },
    
    //perform ajax call
    fetch: function()
    {
   		var self = this;
      	
      	$.ajaxSetup ({
            // Disable caching of AJAX responses
            cache: false
        });
      
      	$.ajax({
          url: this.activeAjaxPath,
          cache: false
        }).done(function(response){
          
          console.log(response);
          
          var $response = $('<div>'+response+'</div>');
          var $results = $response.find('.filter-results');
          
          options.beforeUpdate(self);
          
          self.updatePagination($results.data('paginatenext'),$results.data('paginateprev'));
          self.updateTarget($($results.html()));
          
          self.currentlyFiltering = false;
          
          options.afterFilter(self);
          
        });
      
    },
    
    //loads the next set of items via pages
    doPage: function(pagePath)
    {
      if (options.beforeFilter(this))
        {
        	
          	this.currentlyFiltering = true;
          	
          	this.lastAjaxPath = this.activeAjaxPath;
          	
          	this.activeAjaxPath = pagePath;
          	
          	this.fetch();
          
        }
    },
    
    //fires the filtering calls etc
    doFilter: function()
    {
      var self = this;
      if (!this.currentlyFiltering)
      {
      	
        this.activeCollectionRadio = $(options.collectionFilterSelector+':checked');
      	this.activeTagRadio = $(options.tagFilterSelector+':checked');
        
        if (options.beforeFilter(this))
        {
        	
          	this.currentlyFiltering = true;
          	
          	this.lastAjaxPath = this.activeAjaxPath;
          	
          	this.activeAjaxPath = this.activeCollectionRadio.val();
          	if (this.activeTagRadio && this.activeTagRadio.length && this.activeTagRadio.val() !== '0')
            {
              	this.activeAjaxPath += '/'+this.activeTagRadio.val();
            }
          	
          	this.fetch();
          
        }
        
      }
      
    },
    
    //replaces the contents of the target with the items...
    updateTarget: function($elements)
    { 
     	$(options.filterTargetSelector).empty().append($elements);
    },
    
    //updates the next and prev buttons and hides/shows them
    updatePagination: function(nextPath,prevPath)
    {
    	if (nextPath && nextPath.length)
        {
          	$(options.filterNextLinkSelector).show().data('src',nextPath);
        }
      	else
        {
          	$(options.filterNextLinkSelector).hide().data('src','');
        }
      
      	if (prevPath && prevPath.length)
        {
          	$(options.filterPrevLinkSelector).show().data('src',prevPath);
        }
      	else
        {
          	$(options.filterPrevLinkSelector).hide().data('src','');
        }
      
    }
    
  }
  
}